import { DependencyList, useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';

type CallbackType = () => void;

export function useEffectOnFocus(
  callback: CallbackType,
  deps: DependencyList = [],
) {
  useFocusEffect(
    useCallback(() => {
      callback();
    }, deps),
  );
}
